import { Image } from '@react-pdf/renderer';
import React from 'react';

/**
 * Renderiza una firma dentro de un documento `@react-pdf/renderer`.
 *
 * **El `src` debe estar YA resuelto** (presigned URL de S3 o path legacy). La
 * resolución de S3 keys debe hacerse en el container/orquestador del PDF via
 * `useSignatureUrls` (o `resolveSignatureUrl` si el flujo es imperativo con
 * `pdf().toBlob()`), porque `useEffect` async no se propaga al render de
 * react-pdf en modo imperativo y queda inconsistente incluso con `usePDF`.
 *
 * @param {string|null|undefined} src URL ya resuelta.
 * @param {object} style Estilo del <Image> de react-pdf.
 */
function PDFSignatureImage({ src, style }) {
  if (!src) return null;
  return <Image source={src} style={style} />;
}

export default PDFSignatureImage;
